import { render, staticRenderFns } from "./wholeModal.vue?vue&type=template&id=771e230b&scoped=true&"
import script from "./wholeModal.vue?vue&type=script&lang=js&"
export * from "./wholeModal.vue?vue&type=script&lang=js&"
import style0 from "./wholeModal.vue?vue&type=style&index=0&id=771e230b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771e230b",
  null
  
)

export default component.exports